import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Legal } from "./components/RecommandSection";
import ScrollToTop from "./components/ScrollToTop";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { lazy, Suspense, useEffect, useState } from "react";
import Blogs from "./pages/Blogs";
import { Toaster } from "react-hot-toast";
import { HelmetProvider } from "react-helmet-async";
import Loader from "./components/Loader";
const Home = lazy(() => import("./pages/Home"));
const JobDescription = lazy(() => import("./pages/JobDescription"));
const ContactUs = lazy(() => import("./pages/resources/ContactUS"));
const AboutUs = lazy(() => import("./pages/resources/AboutUs"));
const TermsOfUse = lazy(() => import("./pages/resources/TermsOfUse"));
const PrivacyPolicy = lazy(() => import("./pages/resources/Privacy&Policy"));
const BlogDetails = lazy(() => import("./pages/BlogDetails"));

let cachedBlinkScript = null;

function App() {
  const [, setSearch] = useState("");

  const location = useLocation();

  useEffect(() => {
    console.log(location.pathname, "call function");

    // Signal old engine instance to stop its background tasks
    const oldAv = window.av;
    if (oldAv) {
      oldAv.destroyed = true;
    }
    // IMPORTANT: Clear window.av so the new script instance can initialize itself (instead of short-circuiting)
    window.av = undefined;

    let scriptElement = null;

    const loadScript = async () => {
      // 1. Wait for GPT to destroy existing slots to prevent duplication/association errors
      await new Promise((resolve) => {
        if (window.googletag && window.googletag.cmd) {
          window.googletag.cmd.push(() => {
            if (typeof window.googletag.destroySlots === "function") {
              window.googletag.destroySlots();
            }
            resolve();
          });
        } else {
          resolve();
        }
      });

      // 2. Fetch/Get script content and patch it with "poison pill" checks
      try {
        if (!cachedBlinkScript) {
          const response = await fetch(`/blinkjobwork.js?t=${Date.now()}`);
          cachedBlinkScript = await response.text();
        }

        // Patch the code in-memory to allow "killing" old instances and preventing errors
        let code = cachedBlinkScript
          .replace(/constructor\s*\(([^)]*)\)\s*{/, "constructor($1) { this.destroyed = false; ")
          .replace(/waitFor\s*\(([^)]*)\)\s*{/, "waitFor($1) { if(this.destroyed) return new Promise(()=>{}); ")
          .replace(/define\s*\(([^)]*)\)\s*{/g, "define($1) { if(this.av && this.av.destroyed) return; ")
          .replace(/triggerRefresh\s*\(([^)]*)\)\s*{/g, "triggerRefresh($1) { if(this.av && this.av.destroyed) return; ")
          .replace(/googletag\.display\(([^)]*)\)/g, "(($1) && googletag.display($1))");

        const wrappedCode = `(function() { \n ${code} \n })();`;

        const blob = new Blob([wrappedCode], { type: "application/javascript" });
        const blobUrl = URL.createObjectURL(blob);

        scriptElement = document.createElement("script");
        scriptElement.src = blobUrl;
        scriptElement.async = true;
        document.body.appendChild(scriptElement);
      } catch (error) {
        console.error("Error loading blinkjobwork.js:", error);
      }
    };

    loadScript();

    return () => {
      if (scriptElement) {
        document.body.removeChild(scriptElement);
        URL.revokeObjectURL(scriptElement.src);
      }
    };
  }, [location.pathname]);
  return (
    <HelmetProvider>
      <Header setSearch={setSearch} />
      <ScrollToTop />

      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Navigate to="/cow-long-us-roblox" replace />} />
          <Route path="/cow-long-us-roblox" element={<Home />} />
          <Route path="/cow-long-us/:id" element={<JobDescription />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/:params" element={<Blogs />} />
          <Route path="/iow-us-roblox/:blogid" element={<BlogDetails />} />
        </Routes>
      </Suspense>
      <Legal />
      <Footer />
      <Toaster position="top-center" reverseOrder={false} />
    </HelmetProvider>
  );
}

export default App;
